import "./GalleryTable.style.css";

import { Link } from "react-router-dom";
import { GameCardState } from "../../../utils/states/ConstructorPageStates/GameCardState";
import { AppRouter } from "../../../utils/enums/AppRouter";
import { useIsMobile } from "../../../utils/functions/useIsMobile";
import { GameCard } from "../../../components/special/GameCard/GameCard";
import { GameCardMobile } from "../../../components/special/GameCard/GameCardMobile";

import loadingImage from "./../../../resources/images/loading.png";
import errorLoadingImage from "./../../../resources/images/error_loading.png";

interface GalleryTableProps {
  gameCards: GameCardState[];
  isGamesReceived: boolean;
}

export const GalleryTable = ({
  gameCards,
  isGamesReceived,
}: GalleryTableProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="gallery-table__wrapper">
      {isGamesReceived ? (
        gameCards.length === 0 ? (
          <div className="not_found_container header_2">
            <img src={errorLoadingImage} alt="not found" />
            Игр не найдено
          </div>
        ) : (
          <div className="gallery-table">
            {gameCards.map((gameCard, index) => (
              <Link
                to={
                  gameCard.apiId
                    ? AppRouter.Game.replace(":gameId", gameCard.apiId)
                    : AppRouter.MyGames
                }
                key={index}
              >
                {isMobile ? (
                  <GameCardMobile gameCard={gameCard} key={index} />
                ) : (
                  <GameCard gameCard={gameCard} key={index} />
                )}
              </Link>
            ))}
          </div>
        )
      ) : (
        <div className="loading_block header_2">
          <img className="loading" src={loadingImage} alt="loading..." />
          Загружаем...
        </div>
      )}
    </div>
  );
};
